import React from 'react';

import { FAQ_SHORTCODE, GTM_CLASS, GTM_CLASS_PREFIX } from '../../lib/constant';
import { useMediaQuery } from '../../utils/hooks/useMediaQuery';
import BREAK_POINTS from '../../utils/breakpoint';
import { parseCategories } from '../../utils/parseCategories';
import classnames from 'classnames';

import styles from './Faq.module.scss';
import { ICategoriesNodes } from '../../lib/types';

interface FaqProps {
  title?: string;
  content?: string;
  isSidebar?: boolean;
  isContent?: boolean;
  categories?: ICategoriesNodes;
}

const Faq = (props: FaqProps) => {
  const { title, content, isSidebar = false, isContent = false, categories } = props;
  let showIt = false;

  const isDesktop = useMediaQuery(BREAK_POINTS.desktop);
  const isTablet = useMediaQuery(BREAK_POINTS.tablet);
  const categorySlug = parseCategories.getSlug(categories);

  if (isSidebar) {
    showIt = isDesktop;
  }

  if (isContent) {
    showIt = !isTablet;
  }

  return (
    <>
      {showIt && (
        <div className={styles.Faq}>
          <div className={styles.Faq__title}>{title || FAQ_SHORTCODE.title}</div>
          <div className={styles.Faq__content}>{content || FAQ_SHORTCODE.content}</div>
          <div
            className={classnames(
              styles.Faq__button,
              GTM_CLASS.VIEW_MORE_FAQ,
              `${GTM_CLASS_PREFIX}${categorySlug}`,
            )}
          >
            <a href="#faq-section" title="Jump to Faq">
              <i className={`iconSprites iconSprites-arrowDown-whiteSmall`} />
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Faq;
